import React from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import './PowerBIEmbed.css';

function PowerBIEmbedComponent({ embedUrl }) {
  
  const embedConfig = {
    type: 'report',
    embedUrl: embedUrl,
    tokenType: models.TokenType.Embed,
    settings: {
      panes: {
        filters: {
          expanded: false,
          visible: true
        },
        pageNavigation: {
          visible: true,
          position: models.PageNavigationPosition.Left
        }
      },
      background: models.BackgroundType.Transparent,
      layoutType: models.LayoutType.Custom,
      customLayout: {
        displayOption: models.DisplayOption.FitToPage
      },
      bars: {
        actionBar: {
          visible: false
        }
      }
    }
  };

  const eventHandlers = new Map([
    ['loaded', function () {
      console.log('Power BI Report loaded');
    }],
    ['rendered', function () {
      console.log('Power BI Report rendered');
    }],
    ['error', function (event) {
      console.error('Power BI Report error:', event.detail);
    }]
  ]);

  return (
    <div className="powerbi-embed-wrapper">
      <PowerBIEmbed
        embedConfig={embedConfig}
        eventHandlers={eventHandlers}
        cssClassName="powerbi-report-container"
        getEmbeddedComponent={(embeddedReport) => {
          window.powerBiReport = embeddedReport;
        }}
      />
    </div>
  );
}

export default PowerBIEmbedComponent;
